import { render, staticRenderFns } from "./Step1NewAdminCenterDialog.vue?vue&type=template&id=2f63d1e8&scoped=true"
import script from "./Step1NewAdminCenterDialog.vue?vue&type=script&lang=js"
export * from "./Step1NewAdminCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./Step1NewAdminCenterDialog.vue?vue&type=style&index=0&id=2f63d1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63d1e8",
  null
  
)

export default component.exports